import { render, staticRenderFns } from "./evasion.vue?vue&type=template&id=457ee8bc&scoped=true"
import script from "./evasion.vue?vue&type=script&lang=js"
export * from "./evasion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ee8bc",
  null
  
)

export default component.exports